import { RootState } from '../../';
import { NavigationPages } from '@ax/constants';
import { navigationInitialState } from './';

export const selectNavigation = (state: RootState) =>
  state.navigation || { ...navigationInitialState };
export const selectCurrentPage = (state: RootState) => {
  return selectNavigation(state).currentPage;
};
export const selectCurrentSection = (state: RootState) => selectNavigation(state)?.currentSection;
export const selectUnsavedChanges = (state: RootState) => ({
  unsavedChanges: selectNavigation(state).unsavedChanges,
  unsavedChangesSource: selectNavigation(state).unsavedChangesSource,
});
export const selectIsPageActive =
  (page: NavigationPages | NavigationPages[]) => (state: RootState) => {
    const currentPage = selectCurrentPage(state);
    return Array.isArray(page) ? page.includes(currentPage) : page === currentPage;
  };

export const selectUnsavedChangesModal = (state: RootState) =>
  selectNavigation(state).unsavedChangesModal;
